import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'formly-repeat-section',
  template: `
    <div class="flex flex-col gap-4">
      @for (field of field.fieldGroup; track $index; let i = $index) {
        <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <formly-field [field]="field"></formly-field>
          @if (!props['readonly'] && canRemove()) {
            <div class="flex justify-end mt-2">
              <button mat-raised-button color="warn" type="button" (click)="remove(i)">
                <i class="fa-solid fa-trash mr-2"></i> Remove
              </button>
            </div>
          }
        </div>
      }
      @if (!props['readonly']) {
        <button mat-raised-button color="primary" type="button" (click)="addItem()">
          <i class="fa-solid fa-plus mr-2"></i> {{ props['addText'] || 'Add' }}
        </button>
      }
    </div>
  `,
  imports: [CommonModule, FormlyModule, MatButtonModule],
})
export class RepeatSectionTypeComponent extends FieldArrayType {
  addItem(): void {
    // Add at the end (undefined index) with the initial value from props
    const initialValue = this.props['addValue'] ? { ...this.props['addValue'] } : {};
    this.add(undefined, initialValue);
  }

  canRemove(): boolean {
    const minItems = this.props['minItems'] || 0;
    return (this.field.fieldGroup?.length || 0) > minItems;
  }
}
